<template>
    <div>
        <CommonPopupFrame :changeHeight="70" :changeBottom="0" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="padding-left: 12px; margin-top: 12px; border-bottom: 1px solid #ebebeb; padding-bottom: 16px;">
                <div style="display: flex; align-items: center; gap: 8px; position: relative;">
                    <img @click="closeCompleteAction" style="width: 42px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                    <div style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700;">공유하기</div>
                </div>
            </div>
            <div style="flex: 1; overflow: hidden;" @touchmove.stop="() => { }">
                <InfinityScroll style="height: 100%;" :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="refresh">
                    <div style="padding: 12px 12px 0px 12px;">
                        <div v-for="each, i in memberTalkList" :key="i" style="margin-bottom: 20px;">
                            <div v-if="each.type == JOIN_CHAT_TYPE.GROUP" style="display: flex; align-items: center; gap: 12px;">
                                <div style="display:grid; grid-template-columns: 1fr 1fr;">
                                    <ProfileImage :image-path="each.image_paths[0] ? each.image_paths[0] : ''" style="width:21px; height:21px; border-radius:50%;" :writer-type="0" :is-show-border="false" />
                                    <ProfileImage :image-path="each.image_paths[1] ? each.image_paths[1] : ''" style="width:21px; height:21px; border-radius:50%;" :writer-type="0" :is-show-border="false" />
                                    <ProfileImage :image-path="each.image_paths[2] ? each.image_paths[2] : ''" style="width:21px; height:21px; border-radius:50%;" :writer-type="0" :is-show-border="false" />
                                    <ProfileImage :image-path="each.image_paths[3] ? each.image_paths[3] : ''" style="width:21px; height:21px; border-radius:50%;" :writer-type="0" :is-show-border="false" />
                                </div>
                                <div style="flex: 1;">
                                    <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 10px;">
                                        <div style="color: #808080; font-weight: 500; font-size: 12px;">멤버톡</div>
                                        <span style="display: inline-block; width: 2px; height: 2px; background-color: #808080; border-radius: 50%;"></span>
                                        <div style="color: #808080; font-weight: 500; font-size: 12px;">{{ each.cur_count }}명</div>
                                    </div>
                                    <div style="font-weight: 700; font-size: 14px;">{{ each.title }}</div>
                                </div>
                                <div v-if="each.chat_idx !== selectIdx" @click="sendChat(each.chat_idx, each.type)" style="width: 56px; height: 36px; border-radius: 12px; background-color: #f5f5f5; line-height: 36px; color: var(--color-main); text-align: center; font-size: 12px;">보내기</div>
                                <div v-else-if="each.chat_idx === selectIdx" style="width: 56px; height: 36px; border-radius: 12px; background-color: var(--color-main); line-height: 36px; color: var(--color-main); text-align: center;">
                                    <img style="width: 13px;" :src="require('@/assets/img/check_white.png')" alt="">
                                </div>
                            </div>
                            <!-- <div v-if="each.type == JOIN_CHAT_TYPE.MERCENARY_REQUEST || each.type == JOIN_CHAT_TYPE.MERCENARY_PROPOSE" style="width:40px; display:grid; place-items: center;">
                                <div style="display:grid; place-items: center; font-size:0px;">
                                    <ProfileImage :image-path="each.image_path" style="width:40px; height:40px; border-radius:50%;" :writer-type="each.single_member_type" :is-show-border="false" />
                                </div>
                            </div> -->
                            <div v-if="each.type == JOIN_CHAT_TYPE.OPEN" style="display: flex; align-items: center; gap: 12px;">
                                <div style="display:grid; grid-template-columns: 1fr">
                                    <div :style="{ backgroundColor: $GlobalStore.loginInfo().region_code == each.region_code ? '#f76a1c' : '#d9d9d9' }" style="display:grid;place-items: center; width:40px; height:40px;border-radius:50%;">
                                        <img :src="require('@/assets/act.png')" style="width:25px; height:20px; ">
                                    </div>
                                </div>
                                <div style="flex: 1;">
                                    <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 10px;">
                                        <div style="color: #808080; font-weight: 500; font-size: 12px;">홈 오픈멤버톡</div>
                                        <span style="display: inline-block; width: 2px; height: 2px; background-color: #808080; border-radius: 50%;"></span>
                                        <div style="color: #808080; font-weight: 500; font-size: 12px;">{{ each.cur_count }}명</div>
                                    </div>
                                    <div style="font-weight: 700; font-size: 14px;">{{ each.place_name }}</div>
                                </div>
                                <div v-if="each.chat_idx !== selectIdx" @click="sendChat(each.chat_idx, each.type)" style="padding: 0 12px; height: 36px; border-radius: 12px; background-color: #f5f5f5; line-height: 36px; color: var(--color-main); text-align: center; font-size: 12px;">오픈멤버톡에 공유하기</div>
                                <div v-else-if="each.chat_idx === selectIdx" style="width: 56px; height: 36px; border-radius: 12px; background-color: var(--color-main); line-height: 36px; color: var(--color-main); text-align: center;">
                                    <img style="width: 13px;" :src="require('@/assets/img/check_white.png')" alt="">
                                </div>
                            </div>
                            <div v-else-if="each.type == JOIN_CHAT_TYPE.SINGLE" style="display: flex; align-items: center; gap: 12px;">
                                <div style="display:grid; place-items: center; font-size:0px;">
                                    <ProfileImage :image-path="each.single_image_path" style="width:40px; height:40px; border-radius:50%;" :writer-type="each.single_member_type" :is-show-border="false" />
                                </div>
                                <div style="flex: 1;">
                                    <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 10px;">
                                        <div style="color: #808080; font-weight: 500; font-size: 12px;">1:1 멤버톡</div>
                                        <span style="display: inline-block; width: 2px; height: 2px; background-color: #808080; border-radius: 50%;"></span>
                                        <div style="color: #808080; font-weight: 500; font-size: 12px;">1명</div>
                                    </div>
                                    <div style="font-weight: 700; font-size: 14px;">{{ each.single_nic_name }}</div>
                                </div>
                                <div v-if="each.chat_idx !== selectIdx" @click="sendChat(each.chat_idx, each.type)" style="width: 56px; height: 36px; border-radius: 12px; background-color: #f5f5f5; line-height: 36px; color: var(--color-main); text-align: center; font-size: 12px;">보내기</div>
                                <div v-else-if="each.chat_idx === selectIdx" style="width: 56px; height: 36px; border-radius: 12px; background-color: var(--color-main); line-height: 36px; color: var(--color-main); text-align: center;">
                                    <img style="width: 13px;" :src="require('@/assets/img/check_white.png')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </InfinityScroll>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame";
import InfinityScroll from '@/components/common/InfinityScroll';
import ProfileImage from '@/components/common/ProfileImage';
import { JOIN_CHAT_TYPE } from "@/Constants";
import ResponseCode from "../../ResponseCode";
import { PUSH_ACTION } from "../../Constants";
// import ResponseCode from '../../ResponseCode';

export default {
    name: 'ShareSchedule',
    components: {
        CommonPopupFrame, InfinityScroll, ProfileImage
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        scheduleIdx: {
            type: [Number, String],
            default: -1
        }
    },
    data() {
        return {
            page: 1,
            memberTalkList: [],
            isEnableNextPageHandle: true,
            JOIN_CHAT_TYPE: JOIN_CHAT_TYPE,
            isSend: false,
            selectIdx: ''
        }
    },
    methods: {
        async sendChat(chat_idx, chat_type) {

            this.isSend = true
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleIdx)
            formData.append('chat_idx', chat_idx)
            formData.append('chat_type', chat_type)
            this.selectIdx = chat_idx

            const res = await this.$Axios.post('/api/join/open/schedule/share', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                if (chat_type == JOIN_CHAT_TYPE.OPEN) {
                    window.pushCustomManager.goScreen('empty', chat_idx, PUSH_ACTION.OPEN_TALK, res.data.region_code, '');
                    localStorage.setItem('isShared', true)
                    localStorage.setItem('isShowSchedulePopup', true)
                } else {
                    await this.$Axios.showChattingBySoccerJoinIdx(chat_idx);
                    this.closeCompleteAction()
                }
                // if (res.data.isPositionProIssued) {
                //     this.$GlobalStore.setIsShowCompleteProCondition()
                // }
            }
        },
        async getMemberTalkList() {
            this.isEnableNextPageHandle = false;
            const parameters = {}
            parameters.page = this.page
            parameters.is_for_share = true
            const res = await this.$Axios.get('/api/chat/chats', { params: parameters })

            const result = res.data.joinChats

            if (result.length > 0) {
                this.isEnableNextPageHandle = true;
                this.memberTalkList = [...this.memberTalkList, ...result];
            }
        },
        handleNextPage() {
            this.page++
            this.getMemberTalkList()
        },
        refresh() {
            this.page = 1
            this.memberTalkList = []
            this.getMemberTalkList()
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.page = 1;
                this.memberTalkList = []
                this.selectIdx = ''
                this.getMemberTalkList()
            }
        }
    }
}
</script>

<style scoped>
</style>